import AuthState from "./context/auth/authState";
import RouterMain from "./routers/RouterMain";
import { BrowserRouter } from "react-router-dom";
import React, { useEffect } from "react";
import { datadogRum } from '@datadog/browser-rum';
import TagManager from "react-gtm-module";
import { DATADOG_APPID, DATADOG_CLIENTTOKEN, DATADOG_ENV, DATADOG_SERVICE, DATADOG_SITE, APP_STAGE } from "./enviroments/enviroment";

const App = () => {

  useEffect(() => {
    if(DATADOG_ENV=='prod'){
      datadogRum.init({
        applicationId: DATADOG_APPID,
        clientToken: DATADOG_CLIENTTOKEN,
        site: DATADOG_SITE,
        service: DATADOG_SERVICE,
        env: DATADOG_ENV,
        sessionSampleRate: 50,
        sessionReplaySampleRate: 10,
        defaultPrivacyLevel: 'mask-user-input',
        trackResources: true
      });
      datadogRum.startSessionReplayRecording();
    }
    if(APP_STAGE==="production"){
      TagManager.initialize({
        gtmId: "GTM-PNNR458"
      });
    }
  }, [])

  return (
    <div className="App">
      <BrowserRouter>
        <AuthState>
          <RouterMain />
        </AuthState>
      </BrowserRouter>
    </div>
  );
};

export default App;
